import { useEffect } from 'react';

import { useSelectStoreItemProvider } from '#components/organisms/modals/SelectStoreItemModalFlow.js';
import { useListCampaignBenefits, useShowCampaignById_new } from '@givebacks/api/store';
import { useCrowdFundingTranslations } from 'core';
import { ClickableOptionsCard } from 'core/Components';
import { toTitleCase } from 'core/Utils';
import { LoadingOverlay, Stack, Text, Title } from 'ui';

import { usePeerCreditModal } from '../usePeerCreditModal';

const CampaignDonationOptionsContent = ({
  storeItemId,
  storeId,
}: {
  storeItemId?: string;
  storeId?: string;
}) => {
  const { data: campaign } = useShowCampaignById_new({ campaignId: storeItemId, causeId: storeId });
  const { t } = useCrowdFundingTranslations(storeId);
  const { handlePeerCreditOpen } = usePeerCreditModal();
  const { openModalById } = useSelectStoreItemProvider({});

  return (
    <Stack>
      <Stack>
        <Title fz="md">Select how you want to donate</Title>
        <Text c="gray" fz="sm">
          {`Choose to ${t(
            'donate'
          )} directly to the campaign or explore additional items and donation options
          with ${(campaign?.benefit_options?.title ?? 'extras').toLowerCase()}.`}
        </Text>
      </Stack>
      <ClickableOptionsCard>
        <ClickableOptionsCard.Row title={t('Donation')} onClick={handlePeerCreditOpen} />
        <ClickableOptionsCard.Row
          title={toTitleCase(campaign?.benefit_options?.title ?? 'extras')}
          onClick={() => openModalById('StoreItemBenefitList')}
        />
      </ClickableOptionsCard>
    </Stack>
  );
};

const CampaignDonationOptionsWrapper = ({
  storeItemId,
  storeId,
}: {
  storeItemId?: string;
  storeId?: string;
}) => {
  const { data: campaign, isInitialLoading } = useShowCampaignById_new({
    campaignId: storeItemId,
    causeId: storeId,
  });

  const { data: benefits } = useListCampaignBenefits({
    campaignId: storeItemId,
    causeId: storeId,
    queryOptions: {
      searches: {
        deleted: { value: false },
      },
    },
  });

  const { handlePeerCreditOpen } = usePeerCreditModal();
  const { setMeta } = useSelectStoreItemProvider({});

  useEffect(() => {
    setMeta((prev) => ({
      ...prev,
      isBenefitsEnabled: campaign?.benefit_options?.enabled ?? false,
    }));
    if (!campaign?.benefit_options?.enabled || benefits?.store_items.length === 0) {
      handlePeerCreditOpen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benefits?.store_items.length, campaign?.benefit_options?.enabled]);

  return (
    <Stack>
      <LoadingOverlay visible={isInitialLoading} />
      {!isInitialLoading && (
        <CampaignDonationOptionsContent storeItemId={storeItemId} storeId={storeId} />
      )}
    </Stack>
  );
};

export { CampaignDonationOptionsWrapper as CampaignDonationOptionsContent };
